export class Event {
  title: string;
  description: string;
  discoveryDate: Date;
  occurredDate: Date;
}
